export const PLUGIN_NAME = 'ecommerce-gtm-fe';
export const GTM_EVENTS = {
  create_cart: 'create_cart',
  add_to_cart: 'add_to_cart',
  remove_from_cart: 'remove_from_cart',
  update_cart: 'update_cart',
  begin_checkout: 'begin_checkout',
  add_payment_info: 'add_payment_info',
  purchase: 'purchase',
  select_promotion: 'select_promotion',
  remove_promotion: 'remove_promotion',
  view_cart: 'view_cart',
  view_item: 'view_item'
};
export const BLAZE_ECOMMERCE_EVENTS = {
  create_cart: 'create_cart',
  add_to_cart: 'add_to_cart',
  remove_from_cart: 'remove_from_cart',
  update_cart: 'update_cart',
  begin_checkout: 'begin_checkout',
  add_payment_info: 'add_payment_info',
  purchase: 'purchase',
  select_promotion: 'select_promotion',
  remove_promotion: 'remove_promotion',
  view_cart: 'view_cart',
  view_item: 'view_item'
};
export const LINE_ITEM_ACTION_TYPES = {
  add: 'add',
  remove: 'remove'
};
